<rt-icon-help
  #infoDropdownTrigger="rtOverlayOrigin"
  [class.dropdownOpened]="dropdownOpen"
  [rtTooltip]="translations.clickForHelp | translate"
  rt-overlay-origin
>
</rt-icon-help>
<ng-template
  #infoDropdown="rtConnectedOverlay"
  rt-connected-overlay
  [hasBackdrop]="true"
  [origin]="infoDropdownTrigger"
  [open]="dropdownOpen"
  [positions]="positions"
  (backdropClick)="toggleDropdown(false)"
>
  <rt-dropdown>
    <rt-dropdown-item [hasHoverEffect]="false" (click)="toggleDropdown()">
      <div class="info-dropdown-text">{{ infoText }}</div>
    </rt-dropdown-item>
    <rt-dropdown-item
      *ngIf="link"
      [href]="link"
      hrefTarget="_blank"
      (click)="handleLinkClick(); toggleDropdown()"
    >
      {{ translations.learnMore | translate }}
      <rt-icon name="open-in-new" suffix></rt-icon>
    </rt-dropdown-item>
    <rt-dropdown-item *ngIf="contactSupport" (click)="openIntercomChat(); toggleDropdown()">
      {{ translations.contactSupport | translate }}
    </rt-dropdown-item>
  </rt-dropdown>
</ng-template>
